// extracted by mini-css-extract-plugin
module.exports = {"root":"RoundButton_root__Z5kHO","withBorder":"RoundButton_withBorder__2qtEx","primary":"RoundButton_primary__oihrj"};